var exports = {
  "Oh": "ScrollIndicatorOverlay.module__scrollIndicatorLayer___bVo5LV",
  "U4": "ScrollIndicatorOverlay.module__indicatorSlot___bVo5LV",
  "Hr": "ScrollIndicatorOverlay.module__indicatorSlotTop___bVo5LV",
  "Jm": "ScrollIndicatorOverlay.module__indicatorSlotBottom___bVo5LV",
  "q3": "ScrollIndicatorOverlay.module__indicator___bVo5LV",
  "lL": "ScrollIndicatorOverlay.module__indicatorBrand___bVo5LV",
  "Gi": "ScrollIndicatorOverlay.module__indicatorMention___bVo5LV",
};

module.exports = exports;
